const ppDomains = [
  'precisionplanting.com',
  'fieldviewplus.com',
  'fieldviewcab.com',
  'fieldview.cab'
];

const subdomains = ['twi', 'www', 'orders', 'support', 'events'];

var matchesAny = function(str, arr) {
  return arr.some(function(value) { return str.match(value); });
};

var environment = {
  environments: {
    LOCAL: 'local',
    DEMOSPACE: 'demospace',
    QA1: 'qa1',
    INTEGRATION: 'integration',
    PRODUCTION: 'production'
  },

  salesforce: {
    PRODUCTION: 'orders.climate.com',
    QA1: '.*\.force\.com',
    KNOWLEDGE_US: 'support.climate.com',
    KNOWLEDGE_CA: 'support.climatefieldview.ca',
    KNOWLEDGE_BR: 'support.climatefieldview.com.br',
    KNOWLEDGE_UA: 'support.climatefieldview.com.ua',
    KNOWLEDGE_FR: 'support.climatefieldview.fr',
    KNOWLEDGE_DE: 'support.climatefieldview.de',
    EVENTS: 'events.climate.com'
  },

  serviceDomain: 'climate.com',

  serviceProtocol: 'https://',

  getCurrentHostname: function() {
    return window.location.hostname;
  },

  getEnvHostname: function(env = 'production', hostname = 'climate.com') {
    const envHostnames = {};

    const excludedKeys = ['PRODUCTION', 'DEMOSPACE', 'INTEGRATION'];
    const filteredEnvs = Object.keys(environment.environments).filter(
      key => !excludedKeys.includes(key)
    );

    filteredEnvs.forEach(key => {
      const envValue = environment.environments[key];
      envHostnames[envValue] = `${envValue}.${hostname}`;
    });

    envHostnames[environment.environments.PRODUCTION] = `www.${hostname}`;

    return envHostnames[env];
  },

  isEnv: function(env) {
    if (env === environment.environments.PRODUCTION) {
      if (environment.getCurrentHostname() === 'climate.com') {
        return true;
      }
      
      const [subdomain, ...rest] = environment.getCurrentHostname().split('.');
      const domain = rest.join('.');
      
      if (domain === 'climate.com' && subdomains.includes(subdomain)) {
        return true;
      }

      if (environment.getCurrentHostname().includes('climatefieldview')) {
        return true;
      }
    } else if (
      env === environment.environments.QA1 && 
      environment.getCurrentHostname().match(environment.salesforce.QA1)
    ) {
      return true;
    }

    return environment.getCurrentHostname().includes(env);
  },

  getCurrentEnv: function() {
    return Object.values(environment.environments).find(environment.isEnv);
  },

  isEC2: function () {
    const {LOCAL: _LOCAL, ...restEnvironments} = environment.environments;
    return Boolean(Object.values(restEnvironments).find(environment.isEnv));
  },

  isPrecisionPlanting: function() {
    return matchesAny(environment.getCurrentHostname(), ppDomains);
  },

  isSalesforce: function () {
    return matchesAny(environment.getCurrentHostname(), Object.values(environment.salesforce));
  },

  getServiceHostname: function() {
    switch (environment.getCurrentEnv()) {
      case environment.environments.LOCAL:
        return environment.serviceProtocol +
          environment.getEnvHostname(environment.environments.LOCAL);
      case environment.environments.QA1:
        return environment.serviceProtocol + 'qa1.' + environment.serviceDomain;
      default:
        return environment.serviceProtocol + environment.serviceDomain;
    }
  }
};

module.exports = environment;
